import axios from 'axios'
import localData from '@/utility/localData'
const AdminFedderStore = {
    data: {
    },

    methods:
    {
        AddFeederProfile(
            title,
            feederType,
            type,
            substationName,
            feederName,
            feederVoltage,
            feederLength,
            sanctionedLoadMW,
            csvFile,
            year,
            pincode,
            stateName,
            isPublished,
            powerFactor
        ) {
            const token = localData.methods.getLocalToken()
            let formData = new FormData();
            formData.append('title', title)
            formData.append('feederType', feederType)
            formData.append('profileType', type)
            formData.append('substationName', substationName)
            formData.append('feederName', feederName)
            formData.append('pincode', pincode)
            formData.append('stateName', stateName)
            formData.append('isPublished', isPublished)
            formData.append('feederVoltageKV', feederVoltage)
            formData.append('feederLengthKm', feederLength)
            formData.append('sanctionedLoadMW', sanctionedLoadMW)
            formData.append('powerFactor', powerFactor)
            formData.append('csvFile', csvFile)
            formData.append('profileYear', year)
            return axios.post('loadProfiles',
                formData,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
        },

        async AddDTProfile(
            title,
            feederType,
            type,
            substationName,
            dtName,
            feederLengthKm,
            powerFactor,
            dtCapacityKVA,
            dtTapping,
            primaryVoltage,
            secondaryVoltage,
            csvFile,
            year,
            pincode,
            stateName,
            isPublished,
            sanctionedLoadMW
        ) {
            const token = localData.methods.getLocalToken()
            let formData = new FormData();
            formData.append('title', title)
            formData.append('feederType', feederType)
            formData.append('profileType', type)
            formData.append('substationName', substationName)
            formData.append('dtName', dtName)
            formData.append('isPublished', isPublished)
            formData.append('feederLengthKm', feederLengthKm)
            formData.append('powerFactor', powerFactor)
            formData.append('sanctionedLoadMW', sanctionedLoadMW)
            formData.append('dtCapacityKVA', dtCapacityKVA)
            formData.append('dtTapping', dtTapping)
            formData.append('primaryVoltage', primaryVoltage)
            formData.append('secondaryVoltage', secondaryVoltage)
            formData.append('pincode', pincode)
            formData.append('stateName', stateName)
            formData.append('csvFile', csvFile)
            formData.append('profileYear', year)
            return axios.post('loadProfiles',
                formData,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
        },
       
         AddSubstationProfile(
            title,
            feederType,
            type,
            substationName,
            feederName,
            feederLengthKm,
            totalCapacityMVA,
            feederCount,
            incomingFeederVoltageKV,
            outgoingFeederVoltageKV,
            powerFactor,
            csvFile,
            year,
            pincode,
            stateName,
            isPublished,
            sanctionedLoadMW
        ) {
            const token = localData.methods.getLocalToken()
            let formData = new FormData();
            formData.append('title', title)
            formData.append('feederType', feederType)
            formData.append('profileType', type)
            formData.append('substationName', substationName)
            formData.append('feederName', feederName)
            formData.append('isPublished', isPublished)
            formData.append('feederLengthKm', feederLengthKm)
            formData.append('powerFactor', powerFactor)
            formData.append('sanctionedLoadMW', sanctionedLoadMW)
            formData.append('totalCapacityMVA', totalCapacityMVA)
            formData.append('feederCount', feederCount)
            formData.append('incomingFeederVoltageKV', incomingFeederVoltageKV)
            formData.append('outgoingFeederVoltageKV', outgoingFeederVoltageKV)
            formData.append('pincode', pincode)
            formData.append('stateName', stateName)
            formData.append('csvFile', csvFile)
            formData.append('profileYear', year)
            return  axios.post('loadProfiles',
                formData,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
        },

         AddStateLevelProfile(
            title,
            type,
            csvFile,
            year,
            // pincode,
            // stateName,
            isPublished
        ) {
            const token = localData.methods.getLocalToken()
            console.log('isPublished',isPublished)
            let formData = new FormData();
            formData.append('title', title)
            formData.append('profileType', type)
            formData.append('isPublished', isPublished)
            // formData.append('pincode', pincode)
            // formData.append('stateName', stateName)
            formData.append('csvFile', csvFile)
            formData.append('profileYear', year)
            return  axios.post('loadProfiles',
                formData,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
        },

        AddMasterConstantProfile(
            //yearlychangeinloadperc,
            peakViolationCountForCapacityUpgradation,
            minAcceptableVoltageDeviation,
            maxAcceptableVoltageDeviation,
            yearlySolarDegradationFactor,
            storageRoundTripEfficiency,
            depthOfDischarge,
            inverterEfficiency,
            storageCycleLife,
            peakLoadHoursTimeFactor,
            analysisperiodyears,
            upgradationCapacityUpperLimit,
            loadShiftedAfterUpgradationPercent,
            transmissionCapacityCostINR_MW,
            generationCapacityCostINR_MW,
            emissionRateCo2,
            emissionRateNo2,
            emissionRateSo2,
            emissionRateSPM2_5,
            emissionCostCo2,
            emissionCostNo2,
            emissionCostSo2,
            emissionCostSPM2_5
        ) {

            const token = localData.methods.getLocalToken()
            return axios.post('masterConstants',
                {
                    peakViolationCountForCapacityUpgradation: peakViolationCountForCapacityUpgradation,
                    minAcceptableVoltageDeviation: minAcceptableVoltageDeviation,
                    maxAcceptableVoltageDeviation: maxAcceptableVoltageDeviation,
                    technologyConstants: {
                        yearlySolarDegradationFactor: yearlySolarDegradationFactor,
                        storageRoundTripEfficiency: storageRoundTripEfficiency,
                        depthOfDischarge: depthOfDischarge,
                        inverterEfficiency: inverterEfficiency,
                        storageCycleLife: storageCycleLife
                    },
                    peakLoadHoursTimeFactor: peakLoadHoursTimeFactor,
                    analysisPeriodYears: analysisperiodyears,
                    upgradationCapacityUpperLimit: upgradationCapacityUpperLimit,
                    loadShiftedAfterUpgradationPercent: loadShiftedAfterUpgradationPercent,
                    transmissionCapacityCostINR_MW: transmissionCapacityCostINR_MW,
                    generationCapacityCostINR_MW: generationCapacityCostINR_MW,
                    emissionRates: {
                        emissionRateCo2: emissionRateCo2,
                        emissionRateNo2: emissionRateNo2,
                        emissionRateSo2: emissionRateSo2,
                        emissionRateSPM2_5: emissionRateSPM2_5
                    },
                    emissionCosts: {
                        emissionCostCo2: emissionCostCo2,
                        emissionCostNo2: emissionCostNo2,
                        emissionCostSo2: emissionCostSo2,
                        emissionCostSPM2_5: emissionCostSPM2_5
                    }
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );
        },
         EditProfile(id,data){
            const payload = new FormData();
            Object.keys(data).forEach(key => payload.append(key, data[key]));
            const token = localData.methods.getLocalToken()
            return axios.patch('loadProfiles/' + id,payload,{headers: {
                "Authorization": `Bearer ${token}`
            }}).then((res=>{
                return res
            }));
        },
        ModifyMasterConstantProfile(
            _id,
            peakViolationCountForCapacityUpgradation,
            minAcceptableVoltageDeviation,
            maxAcceptableVoltageDeviation,
            yearlySolarDegradationFactor,
            storageRoundTripEfficiency,
            depthOfDischarge,
            inverterEfficiency,
            storageCycleLife,
            peakLoadHoursTimeFactor,
            analysisperiodyears,
            upgradationCapacityUpperLimit,
            loadShiftedAfterUpgradationPercent,
            transmissionCapacityCostINR_MW,
            generationCapacityCostINR_MW,
            emissionRateCo2,
            emissionRateNo2,
            emissionRateSo2,
            emissionRateSPM2_5,
            emissionCostCo2,
            emissionCostNo2,
            emissionCostSo2,
            emissionCostSPM2_5
        ) {
            const token = localData.methods.getLocalToken()
            return axios.patch('masterConstants/' + _id,
                {
                    peakViolationCountForCapacityUpgradation: peakViolationCountForCapacityUpgradation,
                    minAcceptableVoltageDeviation: minAcceptableVoltageDeviation,
                    maxAcceptableVoltageDeviation: maxAcceptableVoltageDeviation,
                    technologyConstants: {
                        yearlySolarDegradationFactor: yearlySolarDegradationFactor,
                        storageRoundTripEfficiency: storageRoundTripEfficiency,
                        depthOfDischarge: depthOfDischarge,
                        inverterEfficiency: inverterEfficiency,
                        storageCycleLife: storageCycleLife
                    },
                    peakLoadHoursTimeFactor: peakLoadHoursTimeFactor,
                    analysisPeriodYears: analysisperiodyears,
                    upgradationCapacityUpperLimit: upgradationCapacityUpperLimit,
                    loadShiftedAfterUpgradationPercent: loadShiftedAfterUpgradationPercent,
                    transmissionCapacityCostINR_MW: transmissionCapacityCostINR_MW,
                    generationCapacityCostINR_MW: generationCapacityCostINR_MW,
                    emissionRates: {
                        emissionRateCo2: emissionRateCo2,
                        emissionRateNo2: emissionRateNo2,
                        emissionRateSo2: emissionRateSo2,
                        emissionRateSPM2_5: emissionRateSPM2_5
                    },
                    emissionCosts: {
                        emissionCostCo2: emissionCostCo2,
                        emissionCostNo2: emissionCostNo2,
                        emissionCostSo2: emissionCostSo2,
                        emissionCostSPM2_5: emissionCostSPM2_5
                    }
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );
        },
        fetchData() {

            const token = localData.methods.getLocalToken()
            return axios.get('loadProfiles', { headers: { "Authorization": `Bearer ${token}` } }
            );

        },
        getAllMasterConstant() {
            const token = localData.methods.getLocalToken()
            return axios.get('masterConstants', { headers: { "Authorization": `Bearer ${token}` } }
            ).then(response => {
                return response.data._items
            });

        },
        
        async doPublish(id,ispublished) {
            const token = localData.methods.getLocalToken()
            return await axios.patch('loadProfiles/' + id, {
                isPublished: ispublished
            },{ headers: { "Authorization": `Bearer ${token}` } }
            ).then(response => {
                return response.data
            }).catch(error => {
                console.log('Error: ', error)
            });

        },
        async doDelete(id) {
            const token = localData.methods.getLocalToken()
            return await axios.delete('loadProfiles/' + id, { headers: { "Authorization": `Bearer ${token}` } }
            ).then(response => {
                return response
            });

        },
        async createAdminFeederProfile(
            feedertype,
            yearlychangeinloadperc,
            typeofconductor,
            instancesofpeakviolationforcapacityupgradation,
            minacceptablevoltagedeviation,
            maxacceptablevoltagedeviation,
            peakloadhourstimefactor,

        ) {
            return await axios.post('AdminFeederProfile/', {
                feederType: feedertype,
                yearlyChangeinLoadPerc: yearlychangeinloadperc,
                typeOfConductor: typeofconductor,
                instancesOfPeakViolationForCapacityUpgradation: instancesofpeakviolationforcapacityupgradation,
                minAcceptabLeVoltageDeviation: minacceptablevoltagedeviation,
                maxAcceptablEvoltageDeviation: maxacceptablevoltagedeviation,
                peakLoadHoursTimeFactor: peakloadhourstimefactor

            }).then(response => {
                return response
            }).catch(error => {
                console.log('AdminFeederProfile creation Failed ', error)
                return error
            })
        },
        async createAdminTechnology(
            yearlysolardegradationfactor,
            storageroundtripefciency,
            depthofdischarge,
            inverterefciency,
            storagecyclelife
        ) {
            return await axios.post('AdminFeederTechnology/', {
                yearlySolarDegradationFactor: yearlysolardegradationfactor,
                storageroundTripEfficiency: storageroundtripefciency,
                depthOfDischarge: depthofdischarge,
                inverterEfficiency: inverterefciency,
                storageCycleLife: storagecyclelife
            }).then(response => {
                return response
            }).catch(error => {
                console.log('AdminTechnology creation Failed ', error)
                return error
            })
        },
        async createAdminVoder(
            analysisperiodyears,
            upperlimitforcapacityupgradation,
            percentageofloadshiftedafterupgradation,
            transmissioncapacitycost,
            generationcapacitycost,
            overhead,
            underground,
            discountfactor,
            co2rate,
            so2rate,
            no2rate,
            pm2_5rate,
            co2cost,
            so2cost,
            no2cost,
            pm2_5cost

        ) {
            return await axios.post('AdminFeederVoder/', {
                analysisPeriodYears: analysisperiodyears,
                upperLimitForCapacityUpgradation: upperlimitforcapacityupgradation,
                percentageOfLoadShiftedAfterUpgradation: percentageofloadshiftedafterupgradation,
                transmissionCapacityCost: transmissioncapacitycost,
                generationCapacityCost: generationcapacitycost,
                overhead: overhead,
                underground: underground,
                discountFactor: discountfactor,
                co2Rate: co2rate,
                so2Rate: so2rate,
                no2Rate: no2rate,
                pm2_5Rate: pm2_5rate,
                co2Cost: co2cost,
                so2Cost: so2cost,
                no2Cost: no2cost,
                pm2_5Cost: pm2_5cost,

            }).then(response => {
                return response
            }).catch(error => {
                console.log('AdminVoder creation Failed ', error)
                return error
            })
        }
    }


}
export default AdminFedderStore;